import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { uiChangeSkladName } from '../../../actions/ui';
import ReservesApi from '../../../API/warehouse/reserves-api';
import delete_img from '../../../assets/media/bucket.svg';
import { Row } from '../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { MAP_SKLAD, RESERVES_STATUS, RESERVES_STATUS_COLORS, SKLADS_WAREHOUSE, TO_RESERVE, TYPE_BUTTONS } from '../../../constans';
import { formFullDate, getDate } from '../../../utils';
import CreateReserve from './CreateReserve';
import styles from './styles.module.scss';

const width = ['50px', '120px', '120px', '200px'];

function ReservesPage() {
  const skladName = useSelector(store => store.ui.skladName);
  const dispatch = useDispatch();

  const [create, setCreate] = useState(false);
  const [reserves, setReserves] = useState([]);
  const [limit, changeLimit] = useState(20);
  const { role } = useSelector((store) => ({
    role: store.user.role,
    login: store.user.login,
  }));

  const user = useSelector((store) => store.user);


  const getReserves = () => {
    ReservesApi.getAllReserves({ data: { skladName: skladName.short_name } }).then((r) => setReserves(r.reserves));
  };
  const onDelete = (id) => {
    ReservesApi.deleteReserve({ data: { reserveId: id } }).then(() => getReserves());
  };
  useEffect(() => {
    getReserves();
  }, [skladName.short_name]);

  return (
    <>
      <Content>
        {(role === 'admin' || role === 'owner') && (
          <Row style={{ width: '100%', marginBottom: '20px' }}>
            <Button type={TYPE_BUTTONS.GREEN} onClick={() => setCreate(true)} style={{ marginRight: "20px" }}>
              Создать резезв
            </Button>
            <div>
              <Select
                label="Город"
                select={skladName}
                list={SKLADS_WAREHOUSE.filter(item => user.sklads[item.short_name])}
                valueFn={(p) => p.name}
                onSelect={(v) => dispatch(uiChangeSkladName(v))}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </div>
          </Row>
        )}

        <Table>
          <TableHeader whiteHeader={true}>
            <HeaderTitle width={width[0]}>ID</HeaderTitle>
            <HeaderTitle width={width[2]}>Дата отгрузки резерва</HeaderTitle>
            <HeaderTitle width={width[3]}>Площадка</HeaderTitle>
            <HeaderTitle width={width[1]}>Статус</HeaderTitle>
            <HeaderTitle width={width[3]}>Город</HeaderTitle>
            <HeaderTitle width={width[1]}>Создатель</HeaderTitle>
            <HeaderTitle width={width[3]}>Дата создания</HeaderTitle>
          </TableHeader>
          {reserves.slice(0, limit).map((item) => (
            <TableLine key={item.id}>
              <NavLink to={TO_RESERVE(item.id)} className={styles.line_table_link}>
                <TableCell width={width[0]}>{item.id}</TableCell>
                <TableCell width={width[2]}>{getDate(item.time_scheduled)}</TableCell>

                <TableCell width={width[3]}>{item.market}</TableCell>
                <TableCell width={width[1]} style={{ color: `${RESERVES_STATUS_COLORS[item.status]}` }}>
                  {RESERVES_STATUS[item.status]}
                </TableCell>
                <TableCell width={width[3]} >
                  {MAP_SKLAD[item.skladName]}
                </TableCell>
                <TableCell width={width[1]}>{item.creator}</TableCell>
                <TableCell width={width[3]}>{formFullDate(item.date_create)}</TableCell>
              </NavLink>
              <TableCell>
                <ButtonWithTooltip tooltip={'Удалить'} onClick={() => onDelete(item.id)}>
                  <Icon src={delete_img} width={'20px'} />
                </ButtonWithTooltip>
              </TableCell>
            </TableLine>
          ))}
        </Table>

        {reserves.length >= 0 && reserves.length > limit && (
          <Button className={styles.show_more} onClick={() => changeLimit(limit + 10)}>
            Посмотреть ещё <span className={styles.arrow_blue} />
          </Button>
        )}
        {create && (
          <CreateReserve
            close={() => {
              getReserves();
              setCreate(false);
            }}
          />
        )}
      </Content>
    </>
  );
}

export default ReservesPage;
